<template lang="">
  <div style="height:20px"></div>
  <div class="px-3">
    <h5>
      Info
    </h5>
    <div class="row">
      <!-- Left Section -->
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> Username</label>
          <input type="email" class="form-control" placeholder="Username" v-model="my_user.username">
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> Email</label>
          <input type="email" class="form-control" placeholder="Email" v-model="my_user.email">
        </div>

        <div class="mb-3">
          <label class="form-label"><i class="bi bi-card-list"></i> First Name</label>
          <input type="text" class="form-control" placeholder="First Name" v-model="my_user.firstName">
        </div>


        <div class="mb-3">
          <label class="form-label"><i class="bi bi-card-list"></i> Last Name</label>
          <input type="text" class="form-control" placeholder="Last Name" v-model="my_user.lastName">
        </div>


        <div class="mb-3">
          <label class="form-label"><i class="bi bi-envelope"></i> Change Password</label>
          <button type="button" class="btn btn-light ms-2" data-bs-toggle="modal" data-bs-target="#changePasswordModal">Change</button>
        </div>
      </div>

      <!-- Right Section -->
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label"><i class="bi bi-bookmark"></i> Note</label>
          <textarea class="form-control" rows="4" placeholder="Add a note..." v-model="my_user.note"></textarea>
        </div>
      </div>
    </div>
    <button type="button" class="btn btn-primary">
      <font-awesome-icon :icon="['fas', 'floppy-disk']" /> Save</button>

    <!-- Modal -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="changePasswordModalLabel">Change Password</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <input type="text" class="form-control" placeholder="Old Password" >

            <input type="text" class="form-control mt-3" placeholder="New Password" >
            <input type="text" class="form-control mt-2" placeholder="Confirm New Password" >
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    data() {
      return {
        my_user: "",
        email: "",
        username: "",
        firstName: "",
        lastName: "",
        role: "",
        note: ""
      };
    },
    created() {
      this.fetchUsers();
    },
    methods: {
      async fetchUsers() {
        try {
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          this.my_user = data.data;
        } catch (error) {
          console.error('Error fetching dashboard data:', error);
        }

      },
    }
  }
</script>
<style lang="">

</style>